/**
 * Shared copy for the S&S rate-limit condition.
 *
 * Every sandbox and dev share ONE S&S account whose request budget is
 * account-wide, so a tester can be throttled by somebody else's traffic. The
 * API answers HTTP 429 `{"error": "supplier_throttled", "retry_after_seconds"}`
 * for that (and only that); this module turns it into the one sentence testers
 * see, so the inline notice and the snackbar cannot drift apart.
 */

/** The `error` code the API puts on a throttled supplier lookup. */
export const SUPPLIER_THROTTLED = 'supplier_throttled'

/** Used when the API gave no (or a nonsense) wait. S&S says "wait 1 minute". */
export const DEFAULT_RETRY_AFTER_SECONDS = 60

/** A usable whole-second wait, or the default. */
export function normalizeRetryAfter(value) {
    const n = Math.ceil(Number(value))
    return Number.isFinite(n) && n > 0 ? n : DEFAULT_RETRY_AFTER_SECONDS
}

/** "a minute" / "2 minutes": the wait rounded UP to whole minutes. */
function waitPhrase(seconds) {
    const minutes = Math.max(1, Math.ceil(normalizeRetryAfter(seconds) / 60))
    return minutes === 1 ? 'a minute' : `${minutes} minutes`
}

/** The tester-facing sentence for a throttled S&S lookup. */
export function throttleMessage(retryAfterSeconds) {
    return (
        'S&S is rate limiting requests right now. '
        + `Please wait about ${waitPhrase(retryAfterSeconds)} and try again.`
    )
}
